import React from 'react';
import Sidebar from './Sidebar';
import PremiumPageHeader from './components/PremiumPageHeader';

function NotFound() 
{
  return(
      <>
          <div id="outer-container"  className="App"  > 
          <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
              <div id="page-wrap">
                      <PremiumPageHeader
                        module="SYSTEM"
                        title="Not Found"
                        subtitle="The requested URL was not found on this server."
                        modeLabel="VIEW MODE"
                      />
              </div><br/>
          </div> 
      </>
  );
}
export default NotFound;
